import { render, staticRenderFns } from "./new.lists.page.vue?vue&type=template&id=6e0c36c4&"
import script from "./new.lists.page.vue?vue&type=script&lang=js&"
export * from "./new.lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports